import { request } from './utils';

export const postTalentRegistration = async (data, config = undefined) => {
  const url = `public/talent-onboard/`;
  return await request.post(url, data);
};

export const getTalentRegistration = async (uuid, config = undefined) => {
  const url = `public/talent-onboard/${uuid}`;
  return await request.get(url);
};

export const putTalentRegistration = async (uuid, data, config = undefined) => {
  if (!uuid) {
    return await postTalentRegistration(data, config);
  }
  const url = `public/talent-onboard/${uuid}/`;
  return await request.put(url, data, config);
};

export const patchTalentRegistration = async (uuid, data, config = undefined) => {
  if (!uuid) {
    return await postTalentRegistration(data, config);
  }
  const url = `public/talent-onboard/${uuid}/`;
  return await request.patch(url, data, config);
};

export const deleteTalentRegistrationResume = async (uuid, data, config = undefined) => {
  const url = `public/talent-onboard/${uuid}/delete-resume/`;
  return await request.put(url, data);
};

export const submitTalentRegistration = async (uuid, data, config = undefined) => {
  const url = `public/talent-onboard/${uuid}/submit/`;
  return await request.post(url, data);
};

export const postServiceRate = (uuid, data, config = undefined) => {
  const url = `public/talent-onboard/${uuid}/service-rates/`;
  return request.post(url, data);
};

export const putServiceRate = (uuid, serviceRateUuid, data, config = undefined) => {
  const url = `public/talent-onboard/${uuid}/service-rates/${serviceRateUuid}/`;
  return request.put(url, data);
};

export const postTalentRate = (uuid, data, config = undefined) => {
  const url = `public/talent-onboard/${uuid}/talent-rates/`;
  return request.post(url, data);
};

export const putTalentRate = (uuid, talentRateUuid, data, config = undefined) => {
  const url = `public/talent-onboard/${uuid}/talent-rates/${talentRateUuid}/`;
  return request.put(url, data);
};

export const postTalentRegistrationLink = async (uuid, data, config = undefined) => {
  const url = `public/talent-onboard/${uuid}/links/`;
  return await request.post(url, data, config);
};

export const postTalentRegistrationFile = async (uuid, data, config = undefined) => {
  const url = `public/talent-onboard/${uuid}/attachments/`;
  return await request.post(url, data, config);
};

export const deleteTalentRegistrationLink = async (uuid, linkId, config = undefined) => {
  const url = `public/talent-onboard/${uuid}/links/${linkId}/`;
  return await request.delete(url, config);
};

export const deleteTalentRegistrationFile = async (uuid, fileId, config = undefined) => {
  const url = `public/talent-onboard/${uuid}/attachments/${fileId}/`;
  return await request.delete(url, config);
};
